module.exports = __webpack_public_path__ + "img/1f9a4.7ed5766.svg";